import { SORT_ORDER_ASC, SORT_ORDER_DESC } from '@@partner:config/graphql'
import { ROUTE_PRODUCT_ATTRIBUTES_EDIT } from '@@partner:config/routes'
import { useFetchAllProductAttributes } from '@@partner:graphql/query/productAttribute/allProductAttributes.gql'
import { convertToInt } from '@@partner:helpers/util'
import { CommonSort, NestedFilter } from '@@partner:types:graphql'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import React, { useCallback, useState } from 'react'
import { generatePath } from 'react-router-dom'
import ProductAttributesFilter from './grid/ProductAttributesFilter'
import ProductAttributesTable from './grid/ProductAttributesTable'
import { Pagination } from 'rsuite'

export interface ProductAttributeGridProps {
  brandSlug: string
}

export default function ProductAttributeGrid ({ brandSlug }: ProductAttributeGridProps) {
  const [ page, setPage ] = useState(1)
  const [ tableSort, setTableSort ] = useState<CommonSort>({
    fieldName: 'id',
    direction: SORT_ORDER_DESC
  })
  const [ filter, setFilter ] = useState<NestedFilter>({
    fields: [ 'id' ],
    op: 'unwrap'
  })

  const { data, loading, error } = useFetchAllProductAttributes({
    pager: { page },
    sort: tableSort,
    filter
  })

  const generateEditUrl = useCallback(
    (attributeId) => {
      if (!brandSlug) {
        return ''
      }
      return generatePath(ROUTE_PRODUCT_ATTRIBUTES_EDIT, {
        brandSlug,
        attributeId
      })
    },
    [ brandSlug ]
  )

  const handlePageSelect = useCallback((selectedPage: string | number) => {
    setPage(convertToInt(selectedPage))
  }, [])

  const handleSortColumn = useCallback((fieldName, direction) => {
    setTableSort({
      fieldName,
      direction: direction === 'desc' ? SORT_ORDER_DESC : SORT_ORDER_ASC
    })
  }, [])

  const handleFilterChanged = useCallback(
    (updatedFilter: NestedFilter) => {
      setFilter(updatedFilter)
      handlePageSelect(1)
    },
    [ handlePageSelect ]
  )

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Ошибка загрузки атрибутов товарв"
        error={error}
      />
    )
  }

  const pageInfo = data?.allProductAttributes.pageInfo
  
  return (
    <div>
      <ProductAttributesFilter onFilterChanged={handleFilterChanged} />

      <ProductAttributesTable
        productAttributes={data?.allProductAttributes?.edges ?? []}
        loading={loading}
        tableSort={tableSort}
        onSortColumn={handleSortColumn}
        generateEditUrl={generateEditUrl}
      />

      <Pagination
        last
        first
        next
        prev
        ellipsis
        activePage={page}
        pages={pageInfo?.lastPage}
        maxButtons={10}
        onSelect={handlePageSelect}
        total={pageInfo?.total ?? 0}
      ></Pagination>
    </div>
  )
}